import { pt } from '@formkit/i18n'
import { generateClasses } from '@formkit/themes'
import { cpf as cpfValidator, cnpj as cnpjValidator } from 'cpf-cnpj-validator';

function only_digits(node) {
  return typeof node.value === 'string' && /\D/.test(node.value) === false;
}

function cpf(node) {
  return typeof node.value === 'string' && cpfValidator.isValid(node.value);
}

function cnpj(node) {
  return typeof node.value === 'string' && cnpjValidator.isValid(node.value);
}

const config = {
  locales: { pt },
  locale: 'pt',
  config: {
    classes: generateClasses({
      global: {
        outer: 'form',
        label: 'main-form__label',
      },
      text: {
        outer: 'textInput',
        input: '$reset main-form__input',
      },
      number: {
        outer: 'numberInput',
        input: '$reset main-form__input',
      },
      email: {
        outer: 'emailInput',
        input: '$reset main-form__input',
      },
      password: {
        outer: 'passwordInput',
        input: '$reset main-form__input',
      },
      select: {
        outer: 'selectInput',
        input: '$reset main-form__input',
      },
      date: {
        outer: 'dateInput',
        input: '$reset main-form__input',
      },
      checkbox: {
        outer: 'input-checkbox ',
        input: '$reset main-form__input checkboxCustom',
        label: 'label-checkbox',
      },
    }),
  },
  rules: {
    cpf,
    cnpj,
    only_digits,
  },
  messages: {
    pt: {
      validation: {
        required: 'Campo obrigatório',
        only_digits: 'Apenas números',
        cpf: 'CPF inválido',
        cnpj: 'CNPJ inválido',
        length({ args }) {
          if (args.length === 2 && args[0] === args[1]) {
            return `O campo deve ter ${args[0]} caracteres`;
          } else if (args.length === 2) {
            return `O campo deve ter entre ${args[0]} e ${args[1]} caracteres`;
          } else if (args.length === 1) {
            return `O campo deve ter pelo menos ${args[0]} caracteres`;
          }
        },
      }
    }
  }
}
export default config
